import { useEffect, useState } from 'react';
import './pwa.css';

function isOnline() {
  return typeof navigator === 'undefined' || typeof navigator.onLine !== 'boolean' || navigator.onLine;
}

/**
 * Aviso global discreto de "Sin conexión" (brief requisito 5). Las páginas
 * ya muestran su propio error cuando una llamada a la API falla; esto sólo
 * aclara que la causa es la red, con la señal más simple posible
 * (`navigator.onLine` + `online`/`offline`), sin sondear nada.
 */
export function OfflineNotice() {
  const [online, setOnline] = useState(isOnline);

  useEffect(() => {
    function handleOnline() { setOnline(true); }
    function handleOffline() { setOnline(false); }
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div className="gym-offline-banner" role="status">
      Sin conexión
    </div>
  );
}
